import React, { useState, useEffect } from 'react';
import VAddEncaissement from './VAddEncaissement';
import VEncaissementTable from './VEncaissementTable';
import { Container, Row, Col, Button, FormGroup, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { connect } from 'react-redux';
import { clearEncaissementLines } from '../../../flux/actions/encaissementlineActions';
import { addEncaissement, getRemainingEncaissements, clearRemainingEncaissements } from '../../../flux/actions/encaissementActions';
import { getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../../flux/actions/constanteActions';
import { getBanks, clearBanks } from '../../../flux/actions/bankActions';
import { IVEncaissementContainerReduxProps, VEncaissementContainer } from '../../../types/interfaces';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faCheck, faCheckCircle, faExclamationTriangle, faShoppingBasket, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'
import PDFLink, { PreviewBase64, instantPrint, instantUploadToFTP } from '../../pdf/PDFLink';
import { useAlert } from "react-alert";
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../../types/errors';
import moment from "moment";
import Association from '../../consultation/Association';
import { createPlaceholderDrive } from '../../../flux/actions/venteActions';
import { constants } from '../../../types/constants';
import { verifyEncDate } from '../../../services/misc';

const VEncaissementContainerComponent = ({ 
  project,
  encaissementlines,
  clearEncaissementLines,
  // clients,
  addEncaissement,
  isConsultation,
  consulationClients,
  consultationEncaissements,
  consultationContratID,
  consultationIsAssociation,
  consultationAssociations,
  consultationContrat,
  bien,
  switchToBien,
  remiseValue,
  remiseTotalValue,
  prixAafficherValue,
  prixAafficherTotalValue,
  getBanks,
  bank,
  getRemainingEncaissements,
  clearRemainingEncaissements,
  userValue,
  auth
 }: VEncaissementContainer) => {

  const { banks } = bank;
  const [prixBien, setPrixBien] = useState(0);
  const [remiseE, setRemiseE] = useState(0);
  const [prixAafficherE, setPrixAafficherE] = useState(0);
  const [totalEncaissements, setTotalEncaissements] = useState(0);
  const [reliquat, setReliquat] = useState(0);
  const [documentModal, setDocumentModal] = useState(false);
  const [previewBase64, setPreviewBase64] = useState({file: '', fileName: ''});

  const [modalAss, setModalAss] = useState(false);
  const [associationPartInfo, setAssociationPartInfo] = useState<any>('');// machi doublon, w7da tt selecti 1st select, lakhra tt confirmi select
  const [selectedAssociation, setSelectedAssociation] = useState<any>('');
  
  const PREVIEW = "PREVIEW", CHECK = "CHECK", CONFIRM = "CONFIRM";
  const [modalCE, setModalCE] = useState(false);
  const [disableSubmitCE, setDisableSubmitCE] = useState(false);
  const [reEnableCE, setReEnableCE] = useState(false);

  const [blockInput, setBlockInput] = useState(false)
  const [blockInputMsg, setBlockInputMsg] = useState('')
  
  const handleToggleCE = () => setModalCE(!modalCE);
  const handleToggleAss = () => setModalAss(!modalAss);

  const history = useHistory();
  const alert = useAlert();
  
  useEffect(() => {
    let block = false
    let blockMsg

    if(consultationIsAssociation){
      if(selectedAssociation && consultationContrat){
        if(consultationContrat.hasPermission)
          ({block, blockMsg} = verifyEncDate(selectedAssociation.contrat_encaissements, Number(selectedAssociation.PRIX_VENTE || 0), selectedAssociation.originalDate || selectedAssociation.createdAt, consultationContrat?.bien?.minEnc, consultationContrat?.bien?.minEncIsNumber, selectedAssociation.ignoreNonEncaisse, selectedAssociation.forceBlockSaisie))
        else
          ({block, blockMsg} = verifyEncDate(consultationContrat["hp_ass"]?.find(e => e.id == selectedAssociation.id)?.contrat_encaissements, Number(consultationContrat["hp_ass"]?.find(e => e.id == selectedAssociation.id)?.PRIX_VENTE || 0), selectedAssociation.originalDate || selectedAssociation.createdAt, consultationContrat?.bien?.minEnc, consultationContrat?.bien?.minEncIsNumber, selectedAssociation.ignoreNonEncaisse, selectedAssociation.forceBlockSaisie))
      }
    }
    else if(consultationContrat){
      if(consultationContrat){
        if(consultationContrat.hasPermission)
          ({block, blockMsg} = verifyEncDate(consultationEncaissements, Number(consultationContrat.PRIX_NET || 0), consultationContrat.DATE_RESERV, consultationContrat?.bien?.minEnc, consultationContrat?.bien?.minEncIsNumber, consultationContrat.ignoreNonEncaisse, consultationContrat.forceBlockSaisie))
        else
          ({block, blockMsg} = verifyEncDate(consultationContrat["hp_ve"], Number(consultationContrat["hp_ventePrice"] || 0), consultationContrat.DATE_RESERV, consultationContrat?.bien?.minEnc, consultationContrat?.bien?.minEncIsNumber, consultationContrat.ignoreNonEncaisse, consultationContrat.forceBlockSaisie))
      }
    }

    setBlockInput(block)
    setBlockInputMsg(blockMsg)
  }, [consultationIsAssociation, consultationContrat, consultationEncaissements, selectedAssociation])

  useEffect(() => {
    getBanks();
  }, [getBanks]);

  useEffect(() => {
    getRemainingEncaissements();
  }, [getRemainingEncaissements]);

  useEffect(() => () => {
    clearRemainingEncaissements();
  }, []);

  const modalClosedHandleCE = () => {
    if(reEnableCE){
      // clearDALines();
      // setObservationValue('');
      setDisableSubmitCE(false);
      setReEnableCE(false);
    }
  };

  const callbackCE = async (success) => {
    if(success?.vente){
      setReEnableCE(true);
      setModalCE(false);
      clearEncaissementLines();
      setSelectedAssociation('');
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Encaissements ajoutés", {open: `/consultation/${success.vente.id}`, timeout: 0});//, {open: `/consultation/${success.venteID}`, timeout: 0});

      if(success.file){
        setPreviewBase64({file: success.file, fileName: success.fileName});
        setDocumentModal(true);
      }
      // const constantesProjet = await getConstanteProjetInfos(success.vente.PROJET || "");
      // instantPrint({
      //   documentType: "recu",
      //   data: {...success.vente, addedContratEnc: success.addedContratEnc, constantesProjet: constantesProjet, enc: true},
      //   showPreviewWatermark: false,
      // });
      // setTimeout(() => history.push({ pathname: `/consultation/${success.vente.id}` }), 5000)
      return
    }
    if(success?.err?.encExists)
      alert.error("Encaissement(s) déjà saisi(s), ici:", success.err.ventes?.length ? {open: `/consultation/${success.err.ventes[0].id}`, newTab: true, timeout: 5000} : {})
    else
      alert.error("Une erreur s'est produite");
    setDisableSubmitCE(false);
  }

  useEffect(() => {
    if(consultationContrat)
      setRemiseE(consultationContrat.REMISE || 0)
    else if(bien && remiseValue !== undefined)
      setRemiseE(remiseTotalValue ? remiseValue : (remiseValue * bien.SUPERFICIE))
    else
      setRemiseE(0)
  }, [bien?.SUPERFICIE, remiseValue, remiseTotalValue])

  useEffect(() => {
    if(consultationContrat)
      setPrixAafficherE(consultationContrat.PRIX_M_CLIENT || 0)
    else if(bien && prixAafficherValue !== undefined)
      setPrixAafficherE(prixAafficherTotalValue ? prixAafficherValue : (prixAafficherValue * bien.SUPERFICIE))
    else
      setPrixAafficherE(0)
  }, [bien?.SUPERFICIE, prixAafficherValue, prixAafficherTotalValue])

  useEffect(() => {
    // if(bien && bien.PRIX_VENTE !== null && bien.PRIX_VENTE !== undefined)
    if(isConsultation)
      setPrixBien(consultationContrat?.PRIX_NET || 0)
    else if((prixAafficherE !== undefined && prixAafficherE > 0) || (bien && bien.PRIX_VENTE !== null && bien.PRIX_VENTE !== undefined))
      setPrixBien((prixAafficherE || bien?.PRIX_VENTE || 0) - (remiseE || 0))
    else
      setPrixBien(0)
  }, [remiseE, prixAafficherE, bien?.PRIX_VENTE, consultationContrat])
  // }, [bien?.PRIX_VENTE, remiseE])

  useEffect(() => {
    setTotalEncaissements(encaissementlines.reduce((e, t) => {
      return t.PART ? e + Number(t.PART) : e
    }, 0) + (isConsultation ? ((consultationEncaissements || []).reduce((e, t) => {
      return t.PART ? e + Number(t.PART) : e
    }, 0)) : 0))
  }, [encaissementlines, isConsultation, consultationEncaissements])

  useEffect(() => {
    setReliquat(Number(prixBien) - Number(totalEncaissements))
  }, [prixBien, totalEncaissements])

  const consultationAddEncaissements = async action => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    if(!userValue){
      alert.error("Veuillez sélectionner le commercial");
      return
    }
    if(encaissementlines.length === 0){
      alert.error("Veuillez saisir au moins un encaissement");
      return
    }
    if(consultationIsAssociation && (selectedAssociation === '' || !selectedAssociation)){
      alert.error("Veuillez sélectionner une association");
      return
    }

    const encaissementlines_ = encaissementlines.map(e => ({...e, notValid: blockInput}))
    if(action === CHECK){
      setModalCE(true);
      return
    }
    else if(action === CONFIRM){
      if(consultationContratID){
        setDisableSubmitCE(true);
        let recu_image_counter, placeholderData, recuFile
        if(!blockInput){
          const constantesProjet = await getConstanteProjetInfos(consultationContrat?.IDPROJET || -1, consultationContrat?.PROJET || "");
          recu_image_counter = await getConstanteRecuImageIncrem();
          placeholderData = await createPlaceholderDrive(null, 1, recu_image_counter, "S", consultationContrat?.id || -1, consultationContrat?.ID_BIEN || -1, consultationContrat?.TYPE_VENTE === "ASSOCIATION" ? 1 : 0, consultationIsAssociation ? selectedAssociation.id : undefined, 1, 0, auth?.user?.id)
          if(!placeholderData?.fileId || !placeholderData?.webViewLink || !placeholderData?.recuId){
            alert.error("No placeholder")
            setDisableSubmitCE(false)
            return
          }
          recuFile = await instantUploadToFTP({
            documentType: "recu",
            //   data: {...success.vente, addedContratEnc: success.addedContratEnc, constantesProjet: constantesProjet, enc: true},
            data: {...consultationContrat, associationId: consultationIsAssociation ? selectedAssociation.id : undefined, enc: true, addedContratEnc: encaissementlines_.map(e => ({...e, ...(consultationIsAssociation ? {ID_ASS: Number(selectedAssociation.id)} : {}), bank: e.IDBANQUE !== undefined && e.IDBANQUE !== null ? banks.find(t => t.id === e.IDBANQUE) : banks.find(t => t.name === e.BANQUE)})), recu_image_counter, constantesProjet, webViewLink: placeholderData.webViewLink, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined},
            showPreviewWatermark: false,
          });
        }
        let uploads: any[] = [],
          uploadCount = 0;

        for(let i in encaissementlines_){
          if(!encaissementlines_[i].partFrom){
            uploadCount++;
            if(encaissementlines_[i].verso)
              uploadCount++
          }
        }

        const uploadCallback = () => {
          if(uploads.length === uploadCount){
            addEncaissement(consultationContratID, consultationContrat?.bien?.id || 0, consultationIsAssociation ? selectedAssociation.id : undefined, consultationIsAssociation ? 1 : 0, encaissementlines_.map(e => ({...e, ...(consultationIsAssociation ? {ID_ASS: selectedAssociation.id} : {})})), recuFile, placeholderData?.recuId, placeholderData?.fileId, recu_image_counter, uploads, project.id, project.LIBELE, userValue?.id, userValue?.username, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, callbackCE);
          }
        }

        if(uploadCount === 0)
          uploadCallback()
        else{
          const setCodedBuffer = (blob, name, isVerso) => {
            var reader = new FileReader();
            reader.onload = function() {
              var arrayBuffer = this.result,
                codedBuffer: string = "";
              (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
                  codedBuffer += String.fromCharCode(byte);
              });
              uploads.push({codedBuffer, name, isVerso});
              uploadCallback();
            }
            reader.readAsArrayBuffer(blob);
          };

          for(let i in encaissementlines_){
            if(!encaissementlines_[i].partFrom){
              setCodedBuffer(encaissementlines_[i].recto, encaissementlines_[i].REF_REGLEMENT, false);
              if(encaissementlines_[i].verso)
                setCodedBuffer(encaissementlines_[i].verso, encaissementlines_[i].REF_REGLEMENT, true);
            }
          }
        }
      }
      else console.log("no consultationContratID?", consultationContratID)
    }
  };

  return (
    <>
      <VAddEncaissement project={project} consulationClients={consulationClients} isConsultation={isConsultation} consultationContrat={consultationContrat} consultationIsAssociation={consultationIsAssociation} consultationAssociations={consultationAssociations} /*clients={clients}*/ auth={auth} />
      <VEncaissementTable encaissementlinesData={encaissementlines} />
      {isConsultation ? <Container>
        <Row>
          <Col xs="12" md="6" className="text-right">
            <strong>Prix Net : </strong>
          </Col>
          <Col xs="12" md="6">
            {bien ? (prixBien.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ` Dh${remiseE ? ` (dont une remise de ${remiseE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh du total)` : ""}`) : <span className="divSpanAsLinkContent" onClick={switchToBien || function(e){}} title="Basculer à l'onglet des biens"><FontAwesomeIcon icon={faBuilding} />&nbsp;<span>Sélectionner un bien</span></span>}
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="6" className="text-right">
            <strong>Total des encaissements : </strong>
          </Col>
          <Col xs="12" md="6">
            <strong>{totalEncaissements.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}</strong> {prixBien ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((totalEncaissements * 100) / prixBien) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((totalEncaissements * 100) / prixBien)}%)</span> : null}
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="6" className="text-right">
            <strong>Montant restant à payer : </strong>
          </Col>
          <Col xs="12" md="6" style={bien && reliquat < 0 ? {color: "red"} : {}}>
            {bien ? (reliquat.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
          </Col>
        </Row>
      </Container> : null}
      {isConsultation && <Container className="confirmDiv" fixed="down">
        <Row className="justify-content-center">
          {consultationIsAssociation ? <Col xs="10" md="4">
            <div className={`encaissementChooseAsso${selectedAssociation ? " encaissementChooseAssoSelected" : ""}`} title={selectedAssociation ? `${selectedAssociation.POURCENTAGE || "-"}% | ${selectedAssociation.ETAGE === "0" ? "RDC" : `Étage ${selectedAssociation.ETAGE || "-"}`} | ${selectedAssociation.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}` : ""} onClick={() => setModalAss(true)}>
              {!selectedAssociation ? "Choisir une part de l'association" : `${selectedAssociation.POURCENTAGE || "-"}% | ${selectedAssociation.ETAGE === "0" ? "RDC" : `Étage ${selectedAssociation.ETAGE || "-"}`} | ${selectedAssociation.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}`}
              {!!selectedAssociation && <FontAwesomeIcon icon={faTimes} className="encaissementChooseAssoDismiss" onClick={e => {e.stopPropagation(); setSelectedAssociation('')}} />}
            </div>
          </Col> : null}
          <Col xs="12" md="6">
            <FormGroup>
              <Button
                // color="info"
                className={`${/*blockInput ? "btn-danger" : */"btnA"} confirmBtn`}
                onClick={() => /*!blockInput && */consultationAddEncaissements(CHECK)}
                // disabled={blockInput}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;{blockInput ? (blockInputMsg || `${consultationIsAssociation ? "Part" : "Vente"} bloquée pour la saisie`) : `Valider ${encaissementlines.length === 1 ? `l'encaissement` : `les ${encaissementlines.length ? (encaissementlines.length + " ") : ""}encaissements`}`}</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>}
      {isConsultation && <Modal isOpen={modalCE} toggle={handleToggleCE} onClosed={modalClosedHandleCE}>
        <ModalHeader toggle={handleToggleCE}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Confirmation</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="linesConfirmationRow" style={{marginBottom: "24px"}}>
              Voulez-vous vraiment ajouter {encaissementlines.length === 1 ? `l'encaissement` : `les ${encaissementlines.length ? (encaissementlines.length + " ") : ""}encaissements`} {consultationIsAssociation ? "à cette part de l'association" : "à la vente"} ?
            </Row>
            {!!blockInput && <Row className="linesConfirmationRow" style={{marginBottom: "24px", color: "red"}}>
              Le reçu de vente ne sera généré qu'après validation des encaissements par la direction.
            </Row>}
            <Row className="justify-content-center">
              <Button
                className="btnA confirmBtn"
                onClick={() => consultationAddEncaissements(CONFIRM)}
                disabled={disableSubmitCE}
                ><FontAwesomeIcon icon={disableSubmitCE ? faSpinner : faCheckCircle} className={disableSubmitCE ? "spinner" : ""} />&nbsp;&nbsp;Confirmer et Imprimer</Button>
            </Row>
          </Container>
        </ModalBody>
      </Modal>}
      <Modal isOpen={modalAss} toggle={handleToggleAss} className="modal-dialog-large" style={{minWidth: "900px"}} modalClassName="xOverflowModal">
        <ModalHeader toggle={handleToggleAss}><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Choix de l'association</ModalHeader>
        <ModalBody>
          <Association associations={consultationAssociations} etages={consultationContrat?.bien?.ETAGE_ASS} associationPartInfo={associationPartInfo} setAssociationPartInfo={setAssociationPartInfo} chooseForEnc={(e) => {
            setSelectedAssociation(e);
            setModalAss(false);
          }} isModal />
        </ModalBody>
      </Modal>
      <PreviewBase64 base64={previewBase64.file} fileName={previewBase64.fileName} modal={documentModal} setModal={setDocumentModal} />
    </>
  );
};

const mapStateToProps = (state: IVEncaissementContainerReduxProps) => ({
  bank: state.bank,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { clearEncaissementLines, addEncaissement, getBanks, getRemainingEncaissements, clearRemainingEncaissements })(VEncaissementContainerComponent);
